<h1 mat-dialog-title>sorry payment faild</h1>
<div mat-dialog-content>somthing went wrong during payment process</div>
<div mat-dialog-actions>
  <a mat-button href="https://mak-travel.com/">new search </a>
</div>